var AlertSourceType = {
    List: 1,
    Stock:  2
 }
 export default AlertSourceType;